import { render, staticRenderFns } from "./CreateCultureCard.vue?vue&type=template&id=ead2dfce&scoped=true&"
import script from "./CreateCultureCard.vue?vue&type=script&lang=js&"
export * from "./CreateCultureCard.vue?vue&type=script&lang=js&"
import style0 from "./CreateCultureCard.vue?vue&type=style&index=0&id=ead2dfce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead2dfce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VRow,VSelect,VTextField})
